import { useLazyQuery } from '@apollo/react-hooks';
import { ApolloError } from 'apollo-boost';

export const useLazyQueryHook = (QUERY: any, onCompleteFunc: Function, onErrorFunc: Function) => {
    const [callLazyQuery, { loading, error, data }] = useLazyQuery(QUERY, {
        
        onError({ graphQLErrors, networkError,message }: ApolloError) {
            graphQLErrors.map((eachError: any): void => {
                const errorMessage = eachError.message.split(':');
                eachError.message = errorMessage[errorMessage.length > 1 ? 1 : 0];
                return null;
            });
            onErrorFunc({graphQLErrors, networkError});
        },
        onCompleted(result) {
            onCompleteFunc(result)
        },
    });
    return {
        callLazyQuery,
        loading,
        error,
        data
    }
}